var render, staticRenderFns
import script from "./eb-dropdown-divider.vue?vue&type=script&lang=js&"
export * from "./eb-dropdown-divider.vue?vue&type=script&lang=js&"
import style0 from "./eb-dropdown-divider.vue?vue&type=style&index=0&id=cd6410d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd6410d0",
  null
  
)

export default component.exports